import { lazy, Suspense, type ComponentProps } from "react";

// Wrapper lazy: mantém os pacotes @codemirror fora do bundle inicial.
const Inner = lazy(() => import("./CodeEditor").then((m) => ({ default: m.CodeEditor })));

export function CodeEditor(props: ComponentProps<typeof Inner>) {
  return (
    <Suspense fallback={<div style={{ padding: 24, fontSize: 12, color: "var(--ink-dim)" }}>Carregando editor…</div>}>
      <Inner {...props} />
    </Suspense>
  );
}
